import styled from 'styled-components';

export const Box = styled.footer`
  --footer-bg: ${({ $isDarkMode }) => ($isDarkMode ? '#050a08' : '#f6f8f4')};
  --footer-text: ${({ $isDarkMode }) => ($isDarkMode ? '#effff4' : '#24382b')};
  --footer-heading: ${({ $isDarkMode }) => ($isDarkMode ? '#effff4' : '#13251a')};
  --footer-muted: ${({ $isDarkMode }) => ($isDarkMode ? '#98aa9e' : '#526158')};
  --footer-border: ${({ $isDarkMode }) =>
    $isDarkMode ? 'rgba(117, 255, 159, 0.2)' : 'rgba(19, 73, 39, 0.18)'};
  --footer-accent: ${({ $isDarkMode }) => ($isDarkMode ? '#75ff9f' : '#176b38')};
  --footer-accent-contrast: ${({ $isDarkMode }) => ($isDarkMode ? '#07110a' : '#ffffff')};

  width: 100%;
  margin-top: clamp(4rem, 10vw, 8rem);
  border-top: 1px solid var(--footer-border);
  background: var(--footer-bg);
  color: var(--footer-text);
  font-family: 'Courier New', Courier, monospace;
`;

export const Container = styled.div`
  width: min(100% - 2rem, 76rem);
  margin: 0 auto;
  padding: clamp(2.5rem, 6vw, 4.5rem) 0 1.5rem;
`;

export const IntroRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(16rem, 0.6fr);
  align-items: end;
  gap: clamp(2rem, 6vw, 5rem);
  padding-bottom: clamp(2rem, 5vw, 3.5rem);
  border-bottom: 1px solid var(--footer-border);

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    align-items: start;
  }
`;

export const Eyebrow = styled.p`
  margin: 0 0 0.75rem;
  color: var(--footer-accent);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
`;

export const Brand = styled.p`
  margin: 0;
  color: var(--footer-heading);
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: clamp(2rem, 4vw, 3.25rem);
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.045em;
`;

export const Description = styled.p`
  max-width: 42rem;
  margin: 1rem 0 0;
  color: var(--footer-muted);
  font-size: clamp(0.95rem, 1.5vw, 1.05rem);
  line-height: 1.7;
`;

export const ContactButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  min-width: 13rem;
  padding: 0.9rem 1.1rem;
  border: 1px solid var(--footer-heading);
  background: var(--footer-heading);
  color: var(--footer-bg);
  font-family: 'Segoe UI', Arial, sans-serif;
  font-weight: 600;
  text-decoration: none;
  transition: transform 160ms ease, background-color 160ms ease, color 160ms ease;

  &:hover {
    background: var(--footer-accent);
    border-color: var(--footer-accent);
    color: var(--footer-accent-contrast);
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: 3px solid var(--footer-accent);
    outline-offset: 3px;
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 2rem;
  align-items: start;
  padding: clamp(2rem, 5vw, 3rem) 0;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const Column = styled.div`
  min-width: 0;
`;

export const Heading = styled.h2`
  margin: 0 0 1rem;
  color: var(--footer-heading);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

export const LinkList = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
`;

export const FooterLink = styled.a`
  color: var(--footer-text);
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  transition: color 160ms ease;

  &:hover,
  &:focus-visible {
    color: var(--footer-accent);
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;

  .social-icon {
    width: 2.55rem !important;
    height: 2.55rem !important;
    border: 1px solid var(--footer-border);
    border-radius: 2px;
    transition: border-color 160ms ease, transform 160ms ease;
  }

  .social-icon:hover,
  .social-icon:focus-visible {
    border-color: var(--footer-accent);
    transform: translateY(-2px);
    outline: none;
  }
`;

export const BottomRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.75rem 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--footer-border);
  color: var(--footer-muted);
  font-size: 0.78rem;
  line-height: 1.5;

  p {
    margin: 0;
  }
`;
